import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {getFaqList} from '@/api/help/faq';
import {Faq} from '@/api/help/faq/type';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';

export type UseGetFaqListResult = UseQueryResult<
  {
    faqList: Faq[];
    count: number;
    totalPages: number;
    currentPage: number;
  },
  Error
>;

interface UseGetFaqListProps {
  page: number;
  category: string;
}

export const useGetFaqList = ({
  page,
  category,
}: UseGetFaqListProps): UseGetFaqListResult => {
  const {isMobile} = useHelpContext();

  return useQuery({
    queryKey: ['help', 'faq', 'list', category, page],
    queryFn: () => getFaqList({page, category}),
    select: ({data}) => ({
      faqList: data.faqList,
      count: data.faqCount,
      totalPages: Math.ceil(data.faqCount / 10),
      currentPage: page,
    }),
    enabled: !isMobile,
  });
};
